// src/config.ts

let apiUrl: string;
//apiUrl = 'https://round-up-server-e0e4865c3ab8.herokuapp.com';
//apiUrl = 'http://localhost:1337';
if (process.env.NODE_ENV === 'production') {
    apiUrl = 'https://round-up-server-e0e4865c3ab8.herokuapp.com';
} else {
    apiUrl = 'http://localhost:1337';
}

export default {
    apiUrl
};
